module.exports = __webpack_public_path__ + "img/user.d3e52e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/blockChain/user.png
// module id = HhCI
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37